var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cabinet-header'),_c('section',[_c('cabinet-menu'),_c('router-view',{key:_vm.$router.path})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }